let toasts = new function() {
	this.show = (text, time) => {
		window.showToast(text, time, 'info');
		console.log(text);
	};
	this.error = (text, time) => {
		window.showToast(text, time, 'error');
		console.log(text);
	};
}();
export default toasts;



// WEBPACK FOOTER //
// ./src/utils/toasts.js